import databaseInstance from "api";

const dbInstance: any = databaseInstance;

export const getLivePage = async (params: any, query: string) => {
    const { queryKey } = params;
    const [, {
        groupId,
        pageSlug
    }] = queryKey;

    if (!groupId) {
        throw new Error("Community Id Unavailable");
    }

    try {
        const response: any = await dbInstance.get(`/groups/${groupId}/pages/${pageSlug}/live${query}`);
        return response.data;
    } catch (error) {
        throw new Error((error as any).message);
    }
}

export const getLivePageMetaData = async (params: any) => {
    const { queryKey } = params;
    const [, {
        groupId,
        pageSlug
    }] = queryKey;

    if (!groupId) {
        throw new Error("Community Id Unavailable");
    }

    try {
        const response: any = await dbInstance.get(`/meta/groups/${groupId}/pages/${pageSlug}`);
        return response.data;
    } catch (error) {
        throw new Error((error as any).message);
    }
}